//
//
//
//
//
//
//
//
//
//
//
//

import Mapbox from 'mapbox-gl-vue'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  components: { Mapbox },
  data() {
    return {
      accessToken: process.env.MAPBOX_TOKEN,
      mapStyle: 'mapbox://styles/mapbox/dark-v10'
    }
  },
  props: {
    blok: {
      type: Object,
    },
    locations: {
      type: Array,
    }
  },
  methods: {
    loaded(map) {
      // Add markers to the map.
      for (const marker of this.geojson.features) {
        // Create a DOM element for each marker.
        const el = document.createElement('div')
        const width = marker.properties.iconSize[0]
        const height = marker.properties.iconSize[1]
        el.className = 'marker'
        el.style.backgroundImage = 'url(https://a.storyblok.com/f/120533/x/c3656ea275/icon-marker.svg)'
        el.style.width = `${width}px`
        el.style.height = `${height}px`
        el.style.backgroundSize = '100%'
        el.addEventListener('click', () => {
          let list = document.querySelectorAll('[data-loc]')
          for (var i = list.length - 1; i >= 0; i--) {
            list[i].classList.remove('active')
          }
          document.querySelector('[data-loc='+marker.properties.id+']').classList.add('active')
          let html = '<b>'+marker.properties.title+'</b>'+'<p>'+marker.properties.distance+'</p><div class="flex"><a class="btn" href="'+marker.properties.url+'">Store Details</a><a class="btn" href="/order/?store='+marker.properties.id+'">Order Now</a></div>'
          if (!marker.properties.available) {
            html = '<b>'+marker.properties.title+'</b>'+'<p>'+marker.properties.distance+'</p><div class="flex"><a class="btn" href="'+marker.properties.url+'">Store Details</a><a class="btn" href="/menu/">View Menu</a></div>'
          }
          // create the popup
          const popup = new mapboxgl.Popup({ offset: 15 }).setHTML(html)
          // create the marker
          el.style.backgroundImage = 'url(https://a.storyblok.com/f/120533/x/105920791f/icon-marker-active.svg)'
          new mapboxgl.Marker(el)
          .setLngLat({ lng: marker.geometry.coordinates[0], lat: marker.geometry.coordinates[1] })
          .setPopup(popup) // sets a popup on this marker
          .addTo(map)
          map.flyTo({
            center: [marker.geometry.coordinates[0],marker.geometry.coordinates[1]],
            essential: true // this animation is considered essential with respect to prefers-reduced-motion
          , zoom: 10})
          popup.on('close', function(e) {
            el.style.backgroundImage = 'url(https://a.storyblok.com/f/120533/x/c3656ea275/icon-marker.svg)'
          })
        })
        // Add markers to the map.
        new mapboxgl.Marker(el)
        .setLngLat(marker.geometry.coordinates)
        .addTo(map)
      }
    }
  },
  computed: {
    ...mapState([ 'options' ]),
    center() {
      return this.locations[0] ? [this.locations[0].lng,this.locations[0].lat] : [-84.31696832002557,33.82524244271957]
    },
    geojson() {
      let geojson = {
        'type': 'FeatureCollection',
        'features': []
      }
      let locations = this.locations
      for (var i = locations.length - 1; i >= 0; i--) {
        let l = locations[i]
        let closed = l.closed ? 'Closed' : 'Open Now'
        console.log(l)
        let feature = {
          'type': 'Feature',
          'properties': {
            'id': l.id,
            'available': l.available,
            'title': l.address + '<br> ' + l.city + ', ' + l.state + ' ' + l.zip,
            'distance': l.distance.toFixed(2)+ ' mi | '+closed,
            'url': this.options.locationPath+l.path,
            'iconSize': [22, 26]
          },
          'geometry': {
            'type': 'Point',
            'coordinates': [l.lng, l.lat]
          }
        }
        geojson.features.push(feature)
      }
      console.log(geojson)
      return geojson
    },
    hours(hours,closed) {
      if (hours !== undefined) {
        let time = moment(hours.date + ' ' + hours.close, 'YYYY-MM-DD H:mm').format('h a')
        if (closed) {
          return '| Opens at ' + time
        } else {
          return '| Open until ' + time
        }
      }
    },
  }
}
